import { render, staticRenderFns } from "./HabarNoma.vue?vue&type=template&id=2811fdc2&scoped=true"
import script from "./HabarNoma.vue?vue&type=script&lang=js"
export * from "./HabarNoma.vue?vue&type=script&lang=js"
import style0 from "./HabarNoma.vue?vue&type=style&index=0&id=2811fdc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2811fdc2",
  null
  
)

export default component.exports